import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Users, DollarSign, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { KPICard, DataTable, formatCurrency } from '../reportShared';

export default function MemberUtilizationTab({ memberUtilization }) {
  const totalUtilization = memberUtilization.reduce((s, m) => s + m.total_amount, 0);

  return (
    <div className="space-y-6" data-testid="reports-member-utilization-tab">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <KPICard title="Unique Members" value={memberUtilization.length} icon={Users} color="blue" />
        <KPICard title="Total Utilization" value={formatCurrency(totalUtilization)} icon={DollarSign} color="green" />
        <KPICard
          title="Avg per Member"
          value={formatCurrency(memberUtilization.length > 0 ? totalUtilization / memberUtilization.length : 0)}
          icon={TrendingUp}
          color="purple"
        />
        <KPICard
          title="Highest Utilizer"
          value={memberUtilization[0]?.patient_name || 'N/A'}
          subtitle={formatCurrency(memberUtilization[0]?.total_amount)}
          icon={Users}
          color="amber"
        />
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Top Members by Utilization</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={memberUtilization.slice(0, 10)} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" tick={{ fontSize: 10 }} />
              <YAxis dataKey="patient_name" type="category" width={120} tick={{ fontSize: 10 }} />
              <Tooltip formatter={(value) => formatCurrency(value)} />
              <Bar dataKey="total_amount" fill="#0088FE" name="Total Amount" />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle className="text-sm font-medium">Member Utilization Details</CardTitle>
        </CardHeader>
        <CardContent>
          <DataTable
            columns={[
              { key: 'serial_number', header: 'Serial No.' },
              { key: 'patient_name', header: 'Member Name' },
              { key: 'family_id', header: 'Family ID' },
              { key: 'claim_count', header: 'Claims', align: 'center' },
              { key: 'total_amount', header: 'Total Amount', align: 'right', render: (val) => formatCurrency(val) }
            ]}
            data={memberUtilization}
          />
        </CardContent>
      </Card>
    </div>
  );
}
